export default "__VITE_ASSET__71071309__"